// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export interface Validation {
  sectionsValidationResponse: SectionsValidationResponse;
  overlappingEmployees: OverlappingEmployees;
}

export interface SectionsValidationResponse {
  Grade: Grade;
  Goals: Goal;
  Manager: Manager;
}

export interface Grade {
  count: number;
  sectionName: string;
  sectionDescription: string;
  message: string;
  employees: Employee[];
}

export interface Employee {
  id: number;
  displayName: string;
  profilePhoto: string;
  designation?: string;
  ownerType: string;
  employeeFunction?: string;
  email: string;
  preferredName: string;
  cohortName?: string;
}

export interface Goal {
  count: number;
  sectionName: string;
  sectionDescription: string;
  message: string;
  employees: Employee[];
}

export interface Manager {
  count: number;
  sectionName: string;
  sectionDescription: string;
  message: string;
  employees: Employee[];
}

export interface OverlappingEmployees {
  employeeCohortList: EmployeeCohortList[];
  totalUniqueEmployeeCount: number;
}

export interface EmployeeCohortList {
  employeeDetails: Employee;
  cohorts: Cohort[];
}

export interface Cohort {
  id: number;
  name: string;
}

const getReviewCycleValidation = ({ reviewCycleId }: { reviewCycleId: string }): Promise<{ entity: Validation }> => {
  const url = endpoints.reviews.reviewCycleCreation.validation;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
    },
  });
};

export const useGetReviewCycleValidation = ({ reviewCycleId }: { reviewCycleId: string }) =>
  useQuery(
    [REACT_QUERY_KEYS.reviewCreation.validation, reviewCycleId],
    () => getReviewCycleValidation({ reviewCycleId }).then((res) => res.entity),
    { enabled: !!reviewCycleId }
  );

export const useGetOverlappingEmployees = ({ reviewCycleId }: { reviewCycleId: string }) => {
  const { data: validation, isLoading, isSuccess } = useGetReviewCycleValidation({ reviewCycleId });

  return {
    data: validation?.overlappingEmployees?.employeeCohortList || [],
    isLoading,
    isSuccess,
  };
};

export const useGetGradeMissing = ({ reviewCycleId }: { reviewCycleId: string }) => {
  const { data: validation, isLoading, isSuccess } = useGetReviewCycleValidation({ reviewCycleId });

  return {
    data: validation?.sectionsValidationResponse?.Grade?.employees || [],
    isLoading,
    isSuccess,
  };
};

export const useGetGoalsMissing = ({ reviewCycleId }: { reviewCycleId: string }) => {
  const { data: validation, isLoading, isSuccess } = useGetReviewCycleValidation({ reviewCycleId });

  return {
    data: validation?.sectionsValidationResponse?.Goals?.employees || [],
    isLoading,
    isSuccess,
  };
};

export const useManagerMissing = ({ reviewCycleId }: { reviewCycleId: string }) => {
  const { data: validation, isLoading, isSuccess } = useGetReviewCycleValidation({ reviewCycleId });

  return {
    data: validation?.sectionsValidationResponse?.Manager?.employees || [],
    isLoading,
    isSuccess,
  };
};
